import { Collapse } from 'antd';
import SideMenu, { MenuItemType } from '@elem/compCommon/SideMenu';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function MenuNav({ open, callback }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('vanlife');
    // 手机/pad 只展示一级菜单目录
    const lists: any[] = [
        {
            title: t('menu_title'),
            key: '0',
            children: [
                {
                    desc: t('menu_main1'),
                    key: 'vanlife-B',
                },
                {
                    desc: t('menu_main2'),
                    key: 'vanlife-C',
                },
                {
                    desc: t('menu_main3'),
                    key: 'vanlife-D',
                },
                {
                    desc: t('menu_main4'),
                    key: 'vanlife-E',
                },
                {
                    desc: t('menu_main5'),
                    key: 'vanlife-F',
                },
                {
                    desc: t('menu_main6'),
                    key: 'vanlife-G',
                },
                {
                    desc: t('menu_main7'),
                    key: 'vanlife-H',
                },
                {
                    desc: t('menu_main8'),
                    key: 'vanlife-J',
                },
                {
                    desc: t('menu_main9'),
                    key: 'vanlife-K',
                },
                {
                    desc: t('menu_main10'),
                    key: 'vanlife-L',
                },
                {
                    desc: t('menu_main11'),
                    key: 'vanlife-M',
                },
            ],
        },
    ];

    const [items, setItems] = useState([]);

    const renderExpandIcon = (isActive: boolean) => (
        <>
            {isActive ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                    <path d="M2 8.53027H14" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                    <path d="M8 2.53027L8 14.5303" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 8.53027L14 8.53027" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </>
    );

    const handleClick = (key: string) => {
        const target = document.querySelector(`#${key}`) as HTMLElement;
        if (target) {
            window.scrollTo({
                top: target?.offsetTop,
                behavior: 'smooth',
            });
        } else {
            if (!open) callback(true);
            setTimeout(() => {
                const afterOpenTarget = document.querySelector(`#${key}`) as HTMLElement;
                if (afterOpenTarget) {
                    window.scrollTo({
                        top: afterOpenTarget?.offsetTop,
                        behavior: 'smooth',
                    });
                }
            }, 0);
        }
    };

    const handleClickSideMenu = (item: MenuItemType) => {
        const target = document.querySelector(`${item?.link}`) as HTMLElement;
        if (!target) {
            if (!open) callback(true);
            setTimeout(() => {
                const afterOpenTarget = document.querySelector(`${item?.link}`) as HTMLElement;
                if (afterOpenTarget) {
                    window.scrollTo({
                        top: afterOpenTarget?.offsetTop,
                        behavior: 'smooth',
                    });
                }
            }, 0);
        }
    };

    const renderCollapse = (lists: any, level = '1') => {
        if (!lists || !Array.isArray(lists)) return <></>;
        return (
            <Collapse ghost={true} className="collapse-lists" expandIcon={({ isActive }: any) => renderExpandIcon(isActive)} expandIconPosition="right">
                {lists?.map((list: any, k: number) => {
                    return list?.desc ? (
                        <p className="list-desc" key={`level${level}_${k}`} onClick={() => handleClick(list?.key)}>
                            {list?.desc}
                        </p>
                    ) : (
                        <Collapse.Panel className={`list-title level${level} list${list?.key}`} key={`level${level}_${k}`} header={list?.title}>
                            {renderCollapse(list?.children, `${Number(level) + 1}_${k}`)}
                        </Collapse.Panel>
                    );
                })}
            </Collapse>
        );
    };

    useEffect(() => {
        const arr: any[] = [];
        lists[0].children?.map((child: any) => arr.push({ text: child.desc, link: `#${child.key}` } as MenuItemType));
        setItems([...arr]);
    }, []);

    return (
        <nav id="vanlife-menu-nav" className={`vanlife-menu-nav ${css['vanlife-menu-nav']}`}>
            {renderCollapse(lists)}
            <SideMenu items={items} handleCallback={handleClickSideMenu} />
        </nav>
    );
}
